import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [access, setAccess] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      // Fetch access status (trial/sub/locked) — non-blocking
      try {
        const { data: acc } = await api.get("/billing/access");
        setAccess(acc);
      } catch {
        setAccess(null);
      }
    } catch {
      setUser(false);
      setAccess(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // Skip /me check while OAuth callback is processing the session_id fragment
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const value = {
    user,
    access,
    loading,
    setUser,
    refresh: checkAuth,
    refreshAccess: async () => {
      try {
        const { data } = await api.get("/billing/access");
        setAccess(data);
      } catch {}
    },
    logout: async () => {
      try { await api.post("/auth/logout"); } catch {}
      try {
        localStorage.removeItem("rp_chat_session_id");
        localStorage.removeItem("rp_chat_messages");
      } catch {}
      setUser(false);
      setAccess(null);
    },
  };

  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
